module.exports = __webpack_public_path__ + "img/project-34.effc3e33.png";